module.exports = __webpack_public_path__ + "img/sushi1.671d801f.jpg";